import React, { Component } from "react";

import Script from "react-load-script";

import { Box } from "src/components";

class Eventbrite extends Component {
  handleScriptLoad = () => {
    const eventId = this.props.options.eventId;

    window.EBWidgets.createWidget({
      widgetType: "checkout",
      eventId,
      iframeContainerId: `eventbrite-container-${eventId}`,
      modal: false,
      onOrderComplete: () => {},
    });
  };

  render() {
    const { options } = this.props;

    return (
      <Box>
        <div id={`eventbrite-container-${options.eventId}`} />
        <Script
          url="https://www.eventbrite.com/static/widgets/eb_widgets.js"
          onLoad={this.handleScriptLoad}
        />
      </Box>
    );
  }
}

export default Eventbrite;



// WEBPACK FOOTER //
// ./src/components/Content/Module/Eventbrite.js